import { Button, TableItem } from 'components/atoms';
import { LabeledStatus } from 'components/molecules';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetEmails } from 'services/email/email';
import { IEmail } from 'services/email/types';
import { ACTIVE_STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getNodes } from 'utils/table/nodes.utils';

const Emails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading } = useGetEmails();

  const tableData = getNodes<IEmail>(data ?? []);

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`email.list.title`)}
          hideBackButton
          topbarContent={
            <>
              <Button
                variant={BUTTON_VARIANT.submit}
                onClick={() => navigate(`/settings/email/create/`)}>
                <Button.Text
                  text={t(`button.add-what`, {
                    what: t('email.what'),
                  })}
                />
              </Button>
            </>
          }
        />
      }>
      <Table
        id='email-configuration'
        loading={isLoading}
        data={tableData}
        columns={[
          {
            label: t('input.label.name'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.name} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.mailLabel'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.mailLabel} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.host'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.host} isSupplementary />
                <TableItem.Text
                  text={item.port ? `${item.port}` : undefined}
                  isSupplementary
                />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.isActive'),
            renderCell: item => (
              <TableItem>
                <LabeledStatus.Active
                  status={
                    item.isActive
                      ? ACTIVE_STATUS.Active
                      : ACTIVE_STATUS.Inactive
                  }
                />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: item => (
              <TableItem justifyPosition='end'>
                {!item.isPredefined && (
                  <Button isClear onlyIcon onClick={() => navigate(item.id)}>
                    <Button.Description description={t('button.edit')} />


                    <Button.Icon icon={<PiPencilSimpleLine />} />
                  </Button>
                )}
              </TableItem>
            ),
          },
        ]}
        // displayMode
      />
    </TopbarPage>
  );
};

export default Emails;
